<div class="relative">
  <ng-container>
    <!-- Header -->
    <div class="flex justify-between items-center">
      <h2 class="text-gray-400 poppins-medium text-3xl !p-0"> GST Reconciliation</h2>
      <div class="flex justify-between items-center gap-4">
    </div>
    </div>
    <div>
      <p-fieldset legend="Quick Guide to ReconEase" class="poppins-medium shadow-md hover:bg-slate-100 hover:cursor-pointer" >


          <p>1, Bring Credit Register & GSTR 2B into a single file.</p>
          <p>2, Name the sheets: <strong>"<span class="code" (click)="copyToClipboard('Books')">Books</span>"</strong> for Credit Register & <strong>"<span class="code" (click)="copyToClipboard('GSTR - 2B')">GSTR - 2B</span>"</strong> for GSTR 2B data.</p>
          <p>3, Ensure the first row in each sheet contains headers.</p>
          <p>4, Rename selected headers in Books sheet:</p>
            <ul>
              <li>
                <span class="code" (click)="copyToClipboard('BILL_OF_ENTRY_NUMBER')">BILL_OF_ENTRY_NUMBER</span>,
                <span class="code" (click)="copyToClipboard('IGST')">IGST</span>,
              </li>
                          </ul>
          <p>5, Rename selected headers in GSTR-2B sheet:</p>
            <ul>

                <li>
                  <span class="code" (click)="copyToClipboard('BILL_OF_ENTRY_NUMBER')">BILL_OF_ENTRY_NUMBER</span>,
                  <span class="code" (click)="copyToClipboard('IGST')">IGST</span>,
              </li>
                          </ul>
        <p>📌 Upload your file. Enter tolerance & month—sit back and watch the magic happen! ✨</p>

       <p> 🔥 <strong>Pro Tip:</strong> Our system is case-sensitive and space-sensitive. For best results, copy & paste
          sheet names and headers exactly as mentioned! ✅
                        </p>
                        <p>📌 <strong>Note: </strong>To Copy the context please click on the highlighted text.</p>

      </p-fieldset>

    </div>
    <!-- Upload Container -->
    <div class="flex w-full">
      <app-file-upload class="w-full" (selectedFiles)="fileUpload($event)" (reset)="onReset()"
        [requestStatus]="requestStatus"></app-file-upload>
    </div>
    <div>

      <div *ngIf="requestStatus === REQUEST_STATUS.Completed">
        <app-response-download [input]="fileData" [downloadFile]="true"></app-response-download>
      </div>

      <div class="fixed bottom-4 right-2" *ngIf="requestStatus === REQUEST_STATUS.Completed || REQUEST_STATUS.None">
        <button class="bg-primary poppins-semibold text-white px-4 py-2 border-0 outline-none
    rounded-2xl cursor-pointer" (click)="onReset()">Match new file</button>
      </div>
    </div>
  </ng-container>
</div>
  <!-- Dialog for Help -->
  <div class="card flex justify-content-center w-full md:w-2/4 flex-wrap absolute">
    <p-confirmDialog
      icon="pi pi-exclamation-triangle"
      [acceptLabel]="'close'"
      [closable]="true"
      [acceptIcon]="''"
      [rejectVisible]="false"
    />
  </div>